import { AttachmentType } from "./models/attachment";

export interface AddressFields {
  country: string;
  address1: string;
  address2: string;
  saveForFutureUse: boolean;
}

export type NewAddressFieldsState = AddressFields & {
  type: "new";
};

export type ReuseAddressFieldsState = AddressFields & {
  type: "reuse";
  id: string;
};

export type AddressFieldsState =
  | NewAddressFieldsState
  | ReuseAddressFieldsState;

export interface ContactFields {
  name: string;
  phone: string;
  errors: {
    phone: boolean;
  };
}

export type PaymentMethodState =
  | PaymentNone
  | PaymentStripe
  | PaymentBankTransfer;

export interface PaymentNone {
  type: "none";
}

export interface PaymentStripe {
  type: "stripeCreditCard";
  id: string;
  isCreditCardComplete: boolean;
  saveCreditCard: boolean;
  isUsingShipmentAddressForBilling: boolean;
  billingAddress: AddressFieldsState;
}

export interface PaymentBankTransfer {
  type: "custom";
  id: string;
  noteContent: string;
  receiptAttachments: CustomerPaymentReceipt[];
}

export interface CustomerPaymentReceipt {
  id: string;
  type: AttachmentType;
  fileUrl: string;
  fileName: string;
  fileSize: number;
  uploadedSize: number;
  assetId: string | null;
}

export type Currency = "HKD";

export function isCurrency(currency: string): currency is Currency {
  return ["HKD"].some(element => element === currency);
}

export type AmountMap = {
  [key in Currency]: number;
};
